import wasteGlassBottle from '../views/nutrilite/waste-glass-bottle2/wasteGlassBottle'
import relayEvent from '../views/nutrilite/relayevent/relayevent'
import tripleEyeCare from '../views/triple-eye-care/tripleEyeCare'
import selfDiagnosis from '../views/nutrilite/self-diagnosis/index'
import a7070_glister from '../views/nutrilite/a7070-glister'

export default [
  {
    path: '/old/nutrilite/waste-glass-bottle',
    name: 'waste-glass-bottle',
    component: wasteGlassBottle
  },
  {
    path: '/old/nutrilite/relay-event',
    name: 'relayEvent',
    component: relayEvent
  },
  {
    path: '/old/triple-eye-care',
    name: 'triple-eye-care',
    component: tripleEyeCare
  },
  {
    path: '/nutrilite/self-diagnosis',
    name: 'self-diagnosis',
    component: selfDiagnosis
  },
  {
    path: '/a7070-glister',
    name: 'a7070-glister',
    component: a7070_glister
  },
]


// WEBPACK FOOTER //
// ./src/router/nutrilite.js